import { Loading, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { useMemo } from "react";
import styles from "./LoadingView.module.css";
import "./LoadingView.css";

export interface LoadingViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  message?: string;
  fullscreen?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export interface LoadingViewRef {}

export const LoadingView = React.forwardRef(({ message, fullscreen, className, style, ...nativeProps }: LoadingViewProps) => {
  const classes = useMemo(() => {
    const classes = [styles.container];
    if (className) classes.push(className);
    return classes.join(" ");
  }, [className]);
  return (
    <Loading
      className={classes} 
      fullscreen={fullscreen} 
      message={message ?? "Chargement en cours"} 
      {...nativeProps} 
    />
  );
});
